export default (app) => {
  app.mixin({
    methods: {
      $defaultImage(e) {
        e.target.src = require("@/assets/no-image.webp");
      },
    },
  });
};
